import { useRole } from "../state/permissions";

export default function useIsRole(role) {
	return useRole() === role;
}
